export const BRAZE_CONTAINERS_IDS = {
  HOME_SIDE: 'braze-home-side-container',
  HOME_BOTTOM: 'braze-home-bottom-container',
  BLOCK_PAGE_BOTTOM_LEFT: 'braze-block-page-bottom-left',
  SIDEBAR_BOTTOM: 'braze-sidebar-bottom',
};

export const BRAZE_ALIAS_LABELS = {
  EMAIL: 'email',
} as const;
